<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4" v-if="currentModel != null">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title >{{$t('gameVersions.params')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form ref="updateForm">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex xs12>
                <v-text-field
                  :label="$t('gameVersions.name')"
                  v-model="currentModel.name"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :label="$t('instructions.listTitle')"
                  item-text="name"
                  item-value="_id"
                  v-model="currentModel.params.instructions"
                  :items="allInstructions"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('gameVersions.timerActivated')"
                  v-model="currentModel.params.dayTimer"
                ></v-switch>
              </v-flex>
              <v-flex xs12 v-if="currentModel.params.dayTimer">
                <v-text-field
                  :label="$t('gameVersions.timerCount')"
                  type="number"
                  v-model.number="currentModel.params.dayTimerCount"
                  :rules="[v => !!v || $t('fields.required')]"
                  :hint="$t('gameVersions.timerCountHint')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.storageCost')"
                  type="number"
                  v-model.number="currentModel.params.storageCost"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.delayCost')"
                  type="number"
                  v-model.number="currentModel.params.delayCost"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.dd">
                <v-text-field
                  :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.weekNbrAutoCmj')"
                  type="number"
                  v-model.number="currentModel.params.weekNbrAutoCmj"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.dd">
                <v-text-field
                  :append-icon="this.$i18n.locale === 'en' ? 'attach_money' : 'euro_symbol'"
                  :label="$t('gameVersions.changeBufferEveryNbrWeek')"
                  type="number"
                  v-model.number="currentModel.params.changeBufferEveryNbrWeek"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.dd">
                <v-select
                  :items="$store.getters['gameVersions/flowEquationDisplayModes']"
                  :label="$t('gameVersions.flowEquationDisplayModes.title')"
                  item-text="name"
                  item-value="number"
                  v-model="currentModel.params.flowEquationDisplay"
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="currentModel.dd">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('gameVersions.ddOrderPreFilled')"
                  v-model="currentModel.params.ddOrderPreFilled"
                ></v-switch>
              </v-flex>
              <v-flex xs12 >
                <v-select
                  :items="langsList"
                  :label="$t('general.language')"
                  v-model="currentModel.params.lang"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :label="$t('gameVersions.maxOrder')"
                  type="number"
                  v-model.number="currentModel.params.maxOrder"
                  :rules="[v => !!v || $t('fields.required')]"
                  hint
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.gameVersions.loading"
            submit
            flat
            @click.native="update"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.gameVersions.loading"
            submit
            flat
            @click.native="getModel"
          >{{$t('general.cancel')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {

  name: "GameVersionParams",

  components: {},

  data() {
    return {
      currentModel: null
    };
  },

  mounted() {
    this.getAllInstructions()
    this.getModel();
  },

  methods: {

    async getModel() {
      let model = await this.$store.dispatch(
        "gameVersions/getOne",
        this.$route.params.id
      );
      this.currentModel = Object.assign({}, model);
    },

    async update() {
      if (this.$refs.updateForm.validate()) {
        if (
          await this.$store.dispatch("gameVersions/update", {
            id: this.currentModel._id,
            data: this.currentModel
          })
        ) {
          this.getModel();
        }
      }
    },

    ...mapActions('instructions', {
      getAllInstructions: 'getAll'
    })

  },
  
  computed: {
    ...mapGetters('instructions', {
      allInstructions: 'list'
    }),

    ...mapGetters('interfaceSettings', {
      langsList: 'playerLangs'
    })
  }
};
</script>
